import { inject, observer } from "mobx-react";
import MobilePrice from "./mobile/MobilePrice";
import QuantityIndicator from "./QuantityIndicator";
import QuantityControls from "./QuantityControls";
import Tags from "./Tags";
import ProductImage from './ProductImage';
import MobileVariationSelect from "./mobile/MobileVariationSelect";
import MobilePriceInfo from "./mobile/MobilePriceInfo";
import MobileBulkSalePrice from "./mobile/MobileBulkSalePrice";

const ProductViewMobile = inject('studioStore')(observer(({
  product,
  img,
  handleClick,
  selectedVariation,
  setSelectedVariation,
  productType,
  productDisplayType,
  setProductDisplayType,
  handleRemoveFromCart,
  handleAddToCart,
  handleUpdateQuantity,
  productWeightQuantity,
  quantity,
  handleVariationChange,
  handleClearFromCart,
  inCart,
  primaryColorRef,
}) => {

  return (
    <div className="md:hidden flex items-center space-x-2 p-2">
      <div className="shrink-0">
        <ProductImage img={img} productName={product?.name} width={100} height={80} />
        {!!inCart && (
          <div className="absolute top-2 right-2">
            <QuantityIndicator inCart={inCart} handleClearFromCart={handleClearFromCart} />
          </div>
        )}
      </div>
      <div className="flex flex-col flex-1 px-2">
        <Tags product={product} side="reverse" className="mb-2" />
        <div className="flex flex-row justify-between">
          <div>
            <h3
              className="text-base leading-none text-lg font-bold text-heading cursor-pointer font-secondary"
              onClick={handleClick}
              style={{ color: primaryColorRef.current }}
            >
              {product.name}
            </h3>
            <MobilePrice
              product={selectedVariation || product}
              productType={productType}
              productDisplayType={productDisplayType}
              setProductDisplayType={setProductDisplayType}
            />
          </div>
          <MobileVariationSelect
            productType={productType}
            product={product}
            selectedVariation={selectedVariation}
            setSelectedVariation={setSelectedVariation}
            handleVariationChange={handleVariationChange}
            productDisplayType={productDisplayType}
          />
        </div>
        <hr className="dotted-spaced my-1" />
        <div className="flex flex-row justify-between">
          <div>
            <MobilePriceInfo
              product={selectedVariation || product}
              productType={productType}
              productDisplayType={productDisplayType}
              setProductDisplayType={setProductDisplayType}
            />
            <MobileBulkSalePrice
              product={selectedVariation || product}
            />
          </div>
          <div>
            {(productType === "variable" && selectedVariation) || productType === "simple" ? (
              <QuantityControls
                handleRemoveFromCart={handleRemoveFromCart}
                handleAddToCart={handleAddToCart}
                handleUpdateQuantity={handleUpdateQuantity}
                quantity={quantity}
                productWeightQuantity={productWeightQuantity}
                productDisplayType={productDisplayType}
                product={product}
                variant="mobile"
                disableInput
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}));

export default ProductViewMobile;